import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles({
    table: {
        minWidth: 650,
    },
    header: {
        boxShadow: "none",
    },
    fileColumn: {
        width: 280,
    },
    uploadedColumn: {
        width: 175,
    },
    deleteColumn: {
        width: 50,
    },
    subheader: {
        display: "flex",
    },
    subheaderText: {
        fontWeight: "bold",
        padding: "6px 8px",
    },
});
